import React from "react";
import {
  Box,
  Paper,
  TextField,
  Autocomplete,
  Select,
  FormControl,
  InputLabel,
} from "@mui/material";
import { ReactComponent as GradientInputBorder } from "../../../assets/gradient-input-border.svg";

// 左右表示用のグラデーションボーダー（余白あり）
export const GradientBorderBox: React.FC<{
  children: React.ReactNode;
  sx?: any;
  innerRef?: React.Ref<HTMLDivElement>;
}> = ({ children, sx = {}, innerRef }) => {
  return (
    <Box
      ref={innerRef}
      sx={{
        position: "relative",
        background: "linear-gradient(to bottom, #a8a8d4, #ffffff)",
        padding: "2px",
        borderRadius: "10px",
        ...sx,
      }}
    >
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          overflow: "hidden",
        }}
      >
        <Paper
          sx={{
            backgroundColor: "transparent",
            boxShadow: "none",
            borderRadius: "8px",
            padding: "16px",
          }}
        >
          {children}
        </Paper>
      </Box>
    </Box>
  );
};

export interface GradientBorderAutocompleteProps {
  options: string[];
  inputValue: string;
  onInputChange: (event: React.SyntheticEvent, newInputValue: string) => void;
  label: string;
  width?: number;
}

export const GradientBorderAutocomplete: React.FC<GradientBorderAutocompleteProps> = ({
  options,
  inputValue,
  onInputChange,
  label,
  width = 220,
}) => {
  return (
    <Box sx={{ position: "relative", width, height: 40 }}>
      {/* SVGボーダーを背景として配置 */}
      <GradientInputBorder
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          pointerEvents: "none",
          zIndex: 0,
        }}
      />

      {/* Autocompleteを上に配置 */}
      <Autocomplete
        freeSolo
        options={options}
        inputValue={inputValue}
        onInputChange={onInputChange}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder={label}
            size="small"
            sx={{
              width: "100%",
              height: "100%",
              "& .MuiOutlinedInput-root": {
                height: "100%",
                "& fieldset": {
                  border: "none",
                },
                "&:hover fieldset": {
                  border: "none",
                },
                "&.Mui-focused fieldset": {
                  border: "none",
                },
                backgroundColor: "transparent",
                borderRadius: "4px",
              },
              "& .MuiInputBase-input": {
                padding: "8px 12px",
                "&::placeholder": {
                  color: "#999",
                  opacity: 1,
                },
              },
            }}
          />
        )}
      />
    </Box>
  );
};

// ページサイズセレクター
export const PageSizeSelector: React.FC<{
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}> = ({ value, onChange, disabled = false }) => {
  return (
    <FormControl
      size="small"
      sx={{
        minWidth: 120,
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          backgroundColor: 'white',
          '& fieldset': {
            borderColor: 'rgb(194, 140, 255)',
            borderWidth: '2px',
          },
          '&:hover fieldset': {
            borderColor: 'rgb(194, 140, 255)',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'rgb(194, 140, 255)',
          },
        },
      }}
    >
      <InputLabel
        sx={{
          color: 'rgb(194, 140, 255)',
          '&.Mui-focused': {
            color: 'rgb(194, 140, 255)',
          },
        }}
      >
        表示件数
      </InputLabel>
      <Select
        native
        value={value}
        onChange={(e) => onChange(parseInt(e.target.value as string, 10))}
        disabled={disabled}
        label="表示件数"
      >
        <option value={10}>10件</option>
        <option value={20}>20件</option>
        <option value={50}>50件</option>
        <option value={100}>100件</option>
      </Select>
    </FormControl>
  );
};